module.exports = __webpack_public_path__ + "0ad0dbf7cdcb89dff0bbe902b5cf1cfc.png";


//////////////////
// WEBPACK FOOTER
// ../assets/screenshots/simone/simone-journey-map.png
// module id = 544
// module chunks = 0